
import { Component, Vue } from 'vue-property-decorator';
import OrderApiConfig from '@/api/OrderApiConfig';
import { DPApi, GetOrderFellowTravelersRequest } from '@/openapi/order';
import EnvRepository from '@/repository/EnvRepository';

@Component({})
export default class Conf01View extends Vue {
  //* ***********************************************************************************/
  // Computed
  //* ***********************************************************************************/
  get cookieName(): string {
    return EnvRepository.getEnv().VUE_APP_SSO_COOKIE_NAME;
  }

  //* ***********************************************************************************/
  // Methods
  //* ***********************************************************************************/
  doApiGetOrderFellowTravelers(): void {
    const config = OrderApiConfig.newInstance();
    const apiOrder = new DPApi(config);

    const params = new URL(window.location.href).searchParams;

    const request: GetOrderFellowTravelersRequest = {
      acptNo: params.get('acptNo') || null,
      companionEntryId: params.get('companionEntryId') || null,
    };
    const cookie = this.$cookies.get(this.cookieName) || null;
    if (cookie) request.tSTBOJSESSIONID = cookie;

    apiOrder
      .getOrderFellowTravelers(request)
      .then((res) => {
        window.location.href = res.url;
      })
      .catch((error) => {
        error.json().then((res) => {
          if (error.status === 400 && res.errorDetail) {
            sessionStorage.setItem('error', res.errorDetail);
          }
          this.$router.push({
            name: 'Erro01',
          });
        });
      });
  }
}
